export default __webpack_public_path__ + "static/media/Stalker's Bracers of the Grim Cabal.1d2f4550.jpg";